import { GiftCardsHeaderSubTitle, GiftCardsHeaderTitle } from "./GiftCardsHeader.styles";

export interface GiftCardsHeaderProps {
    title: string;
    subTitle: string;
}

function GiftCardsHeader({ title, subTitle }: GiftCardsHeaderProps) {
    return (
        <div>
            <GiftCardsHeaderTitle>
                {title}
            </GiftCardsHeaderTitle>
            <GiftCardsHeaderSubTitle>
                {subTitle}
            </GiftCardsHeaderSubTitle>
        </div>
    )
}

export default GiftCardsHeader;